export class RBNode {
    constructor(color, item, parent, left, right) {
        this.color = color;
        if (item !== undefined)
            this.item = item;
        if (parent !== undefined)
            this.parent = parent;
        if (left !== undefined)
            this.left = left;
        if (right !== undefined)
            this.right = right;
    }
    toString() {
        return this.item.toString();
    }
}
//# sourceMappingURL=rbNode.js.map